// extracted by mini-css-extract-plugin
export default {"card":"Apps-module_card_rVQ82N","notification":"Apps-module_notification_OmeLOK","iconCircle":"Apps-module_iconCircle_ezS6Oy"};